// Next
import Image from 'next/image';

// Contentful
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { RENDER_DOCUMENT_OPTIONS, imageLoader } from '../../helpers/contentful';

// Components
import Button from '../Button/Button';

const AboutHeader = (props) => {
  const { title, description, figure, buttons, storyTitle, storyDescription } = props;

  return (
    <div className="AboutHeader">
      <div className="AboutHeader-inner">
        <div className="AboutHeader-wrapper">
          {(title || description || buttons?.length) && (
            <div className="AboutHeader-text">
              {title && (
                <h1 className="AboutHeader-title">{documentToReactComponents(title, RENDER_DOCUMENT_OPTIONS)}</h1>
              )}
              {description && (
                <div className="AboutHeader-description">
                  {documentToReactComponents(description, RENDER_DOCUMENT_OPTIONS)}
                </div>
              )}
              {buttons?.length >= 1 && (
                <div className="AboutHeader-buttonGroup">
                  {buttons.map((button, buttonIndex) => (
                    <Button
                      label={button.label}
                      url={button.url ? button.url : null}
                      modifier={button.modifier}
                      key={`AboutHeader-button--${buttonIndex}`}
                      target={button.target && button.url ? button.target : null}
                    />
                  ))}
                </div>
              )}
            </div>
          )}
          {figure && (
            <div className="AboutHeader-figure">
              {figure.src && (
                <div className="AboutHeader-image">
                  <div className="AboutHeader-imageWrap">
                    <Image
                      priority
                      layout="fill"
                      objectFit="cover"
                      objectPosition="center"
                      sizes="(min-width: 1440px) 820px,(min-width: 640px) 50vw, 100vw"
                      loader={imageLoader}
                      src={`https:${figure.src}`}
                      alt={figure.alt}
                    />
                  </div>
                </div>
              )}
            </div>
          )}
          {(storyTitle || storyDescription) && (
            <div className="AboutHeader-story">
              <div className="AboutHeader-storyBlock">
                {storyTitle && (
                  <h2 className="AboutHeader-storyTitle">
                    {documentToReactComponents(storyTitle, RENDER_DOCUMENT_OPTIONS)}
                  </h2>
                )}
                {storyDescription && (
                  <div className="AboutHeader-storyDescription">
                    {documentToReactComponents(storyDescription, RENDER_DOCUMENT_OPTIONS)}
                  </div>
                )}
                {buttons?.length >= 1 && (
                  <div className="AboutHeader-storyButtonGroup">
                    {buttons.map((button, buttonIndex) => (
                      <Button
                        label={button.label}
                        url={button.url ? button.url : null}
                        modifier={button.modifier}
                        key={`AboutHeader-button--${buttonIndex}`}
                        target={button.target && button.url ? button.target : null}
                      />
                    ))}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AboutHeader;
